import React from 'react';
import Header from './Header.js';
import Footer from './Footer.js';

const AboutUs = () => {
  return (
    <div className="about-page">
        <section className="content-bg">
        	<Header />
        	<div className="padding-top-xxl padding-bottom-xxl">
	            <div className="container padding-top-xxl padding-bottom-xxl">
	                <div className="row d-flex justify-content-center">
	                    <div className="col-md-12 theme-color text-center">
	                        <h2>About Us</h2>
	                        <p className="custom-para font-md font-weight-extra-light padding-left-xl padding-right-xl padding-top-xl text-center">
	                            After years in the industry, we know the frustrations of measuring—inconsistencies, wasted time, and inefficiencies that slow down production. We’ve faced these challenges ourselves, which is why we set out to create a better solution.
	                        </p>
	                        <p className="custom-para font-md font-weight-extra-light padding-left-xl padding-right-xl padding-top-sm text-center">
								By combining real-world experience with AI-driven technology, we’re offering a solution that simplifies the process without compromising accuracy. Our goal is to make measuring effortless and scalable, so you can focus on delivering quality and growing your business.
							</p>
							<p className="custom-para font-md font-weight-extra-light padding-left-xl padding-right-xl padding-top-sm text-center">
								At our core, we believe in simplicity, accuracy, and long-term partnerships—helping you streamline operations and eliminate guesswork, one measurement at a time.
	                        </p>
	                    </div>                   
	                </div>
	            </div>
            </div>
        </section>
        <Footer />
    </div>
  );
}

export default AboutUs;
